// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface GroupItemsHeaderStyles {
    wrapper?: InjectableCss;
    description?: InjectableCss;
    rightSection?: InjectableCss;
    price?: InjectableCss;
    qty?: InjectableCss;
    total?: InjectableCss;
    actions?: InjectableCss;
}

const sharedStyles = () => `
line-height: ${fontConfig.lineHeight.small};
font-size: ${fontConfig.fontSize.xSmall}px;
font-weight: ${fontConfig.weight.semiBold};
text-transform: uppercase;
letter-spacing: 0.23px;
`;

export const groupHeaderStyles: GroupItemsHeaderStyles = {
    wrapper: {
        css: css`
            display: flex;
            padding: 10px 15px 8px;
            background: ${getColor("common.ui4")};
            border-right: 3px solid ${getColor("common.ui3")};
            border-left: 3px solid ${getColor("common.ui3")};
            @media print {
                display: none;
            }
        `,
    },
    description: {
        css: css`
            flex-grow: 1;
            ${sharedStyles()};
            max-width: 685px;
        `,
    },
    rightSection: {
        css: css`
            display: flex;
            flex: 1;
            @media (max-width: 1301px) {
                display: none;
            }

            @media print {
                display: none;
            }
        `,
    },
    price: {
        css: css`
            flex: 1;
            text-align: left;
            ${sharedStyles()};
        `,
    },
    qty: {
        css: css`
            flex: 1;
            text-align: center;
            ${sharedStyles()};
        `,
    },
    total: {
        css: css`
            flex: 1;
            text-align: right;
            ${sharedStyles()};
        `,
    },
    actions: {
        css: css`
            width: 210px;
            &&.one-button {
                width: 150px;
            }
        `,
    },
};

const GroupItemsHeader = () => (
    <StyledWrapper {...groupHeaderStyles.wrapper}>
        <StyledWrapper {...groupHeaderStyles.description}>{translate("Product Description")}</StyledWrapper>
        <StyledWrapper {...groupHeaderStyles.rightSection}>
            <StyledWrapper {...groupHeaderStyles.price}>{translate("Price/Unit")}</StyledWrapper>
            <StyledWrapper {...groupHeaderStyles.qty}>{translate("Qty")}</StyledWrapper>
            <StyledWrapper {...groupHeaderStyles.total}>{translate("Total")}</StyledWrapper>
            <StyledWrapper {...groupHeaderStyles.actions}></StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

export default GroupItemsHeader;
